import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';
import { IClientRequirementOverride } from 'src/interfaces/clientRequirementOverride';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';

const { Equals } = OdataComparator;

const fetchClientOverridesCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_CLIENT_OVERRIDES_COUNT_SUCCESS',
    payload
  } as const);

export const fetchClientOverridesCount = (
  clientId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const params = new QueryBuilder()
      .orderBy('requestUpdatedDateUtc desc')
      .filter(f => f.filterBy('clientId', Equals, clientId).filterBy('status', Equals, 'Requested'))
      .toQueryParam();

    const { data } = await axios.get<{ value: IClientRequirementOverride[]; '@odata.count': number }>(
      '/api/v3.01/safetyProgramRequirementClientOverrides',
      {
        params
      }
    );
    dispatch(fetchClientOverridesCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchClientOverridesCountSuccess>;
